import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import {
  dateSchema,
  parseToDateValue,
  preprocessTextAsyncAutocompleteField,
} from "@/features/FormCard/utils";
import { z } from "zod";

export const client = "qtl - admin";

export const filterApiKeysSchema = z.object({
  access_token_contains: z.string().nullable().optional(),
  application_name_contains: z.string().nullable().optional(),
  user_email_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional(),
  created_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  created_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  updated_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  updated_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

export type FilterApiKeysSchema = z.infer<typeof filterApiKeysSchema>;

export const fields: Field[] = [
  {
    name: "access_token_contains",
    label: "Access Token",
    type: "input",
  },
  {
    name: "application_name_contains",
    label: "Application Name",
    type: "input",
  },
  {
    name: "user_email_contains",
    label: "User",
    type: "asyncAutocomplete",
    base_url: "admin-quantilia/users",
    column_name: "email",
    id_column: "id",
  },
  {
    name: "created_at_from",
    label: "Created From",
    type: "date",
  },
  {
    name: "created_at_to",
    label: "Created To",
    type: "date",
  },
  {
    name: "updated_at_from",
    label: "Updated From",
    type: "date",
  },
  {
    name: "updated_at_to",
    label: "Updated To",
    type: "date",
  },
];

export function FilterApiKeys() {
  return (
    <FilterTable
      client={client}
      schema={filterApiKeysSchema}
      tableName="api_keys"
      customBuildPath={() => `${client}/api_keys`}
      fields={fields}
    />
  );
}
